module.exports = __webpack_public_path__ + "static/media/zooplus.ed4191ca.svg";